import React from 'react';

export default function MapPin3FillPink({
  alt = '',
  ...props
}: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
  return <img src="/images/map-pin-3-fill-pink.png" alt={alt} width={24} height={24} {...props} />;
}
